//数组方法

import { getValueByPath } from './object'
/**
 *
 * @param {Array} source 原数组
 * @param {Array} selects 原数组中选中的path的值的数组
 * @param {String} path 唯一值的key
 * @returns 返回选中的数组
 */
export function getSelectByPath(source, selects, path) {
  if (!source?.length || !selects?.length || !path) {
    return []
  }
  return source.filter((item) => selects.includes(getValueByPath(item, path)))
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值的key
 * @returns 数组中所有元素对应key的值
 */
export function getKeysByPath(source, path) {
  if (!source?.length || !path) {
    return []
  }
  return source.map((item) => getValueByPath(item, path))
}

/**
 * 获取数组中对应字段的值等于value的数组
 * @param {Array} source 数组
 * @param {String} path 需要返回值的key
 * @returns 数组中所有元素对应key的值
 */
export function getKeysByPathValue(source, path, value) {
  if (!source?.length || !path) {
    return []
  }
  return source.filter((item) => getValueByPath(item, path) === value)
}
/**
 判断对象数组中的指定属性是否包含，对应对值。
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，array} value 对比值
 * return  {boolean} 是否包含
 比如 1：
  arr=[{status:"草稿"}]
  field="status"
  value="草稿"

  return =》 true

  比如 2：
   arr=[{status:"草稿"}]
   field="status"
   value=["草稿","编辑"]

   return =》 true
*/
export const containFieldValue = function (arr, field, value) {
  if (!arr || arr.length == 0) return false
  //每行数据都包含，才返回true，只要有1行不满足则返回false
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    if (Array.isArray(value)) {
      if (value.indexOf(getValueByPath(item, field)) === -1) {
        return false
      }
    } else if (!(getValueByPath(item, field) === value)) {
      return false
    }
  }

  return true
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值key
 * @param {String} filterPath 需要过滤的key
 * @param {isNull} filterPath 需不需要过滤null
 * @returns 数组中所有元素对应key的值
 */
export function getKeysByPathNotNull(source, path, filterPath, isNull = true) {
  if (!source?.length || !path) {
    return []
  }
  return source
    .filter((item) => (!isNull ? true : getValueByPath(item, filterPath)))
    .map((item) => getValueByPath(item, path))
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值key
 * @param {String} filterPath 需要过滤的key
 * @returns 数组中所有元素对应key的值并进行去重
 */
export function getKeysByPathNotNullUnique(source, path, filterPath, isNull) {
  return Array.from(new Set(getKeysByPathNotNull(source, path, filterPath, isNull)))
}

export function getNotNullArr(arr) {
  if (!arr) return []
  return arr.filter((item) => !!item)
}
